export default __webpack_public_path__ + "static/media/mapa_folwarku.b50976be.png";